import styles from './MultiMonthPicker.module.scss'
import { Col, Row } from 'react-bootstrap'
import { FilterOption } from '@/features/travelFilter/types'
import { addLeadingZeros } from '@/lib/helpers/helpers'
import { useTracking } from '@/integrations/tracking/useTracking'

const getYears = () => {
  const currentYear = new Date().getFullYear()
  return [currentYear, currentYear + 1]
}

const buildYearMonths = (year: number) => {
  const months: string[] = []
  Array.from(Array(12)).forEach((x, i) => {
    months.push(`${year}-${addLeadingZeros(i + 1, 2)}`)
  })
  return months
}

interface Props {
  selected: string[]
  setSelected: (selected: string[]) => void
  options: FilterOption[]
}

const MultiMonthPicker = ({ selected, setSelected, options }: Props) => {
  const { send } = useTracking()
  const years = getYears()

  const isMonthDisabled = (monthString: string) => {
    const isActive = selected.includes(monthString)
    if (isActive) {
      return false
    }
    const item = options.find((option) => {
      return option.value === monthString
    })
    if (!item || item.itemCount === 0) {
      return true
    }
  }

  const handleSelect = (monthString: string) => {
    const newSelection = [...selected]
    const index = newSelection.indexOf(monthString)
    const trackingValue = monthString.split('-')[1]
    if (index === -1) {
      // add
      newSelection.push(monthString)
      send.genericEvent({
        category: 'travel_filter',
        object: 'filter_option',
        action: 'add',
        data: {
          filter_type_name: 'month',
          filter_option_value: trackingValue,
        },
      })
    } else {
      // remove
      newSelection.splice(index, 1)
      send.genericEvent({
        category: 'travel_filter',
        object: 'filter_option',
        action: 'remove',
        data: {
          filter_type_name: 'month',
          filter_option_value: trackingValue,
        },
      })
    }
    setSelected(newSelection)
  }

  return (
    <Row className={styles.root}>
      {years.map((year) => {
        const monthStrings = buildYearMonths(year)

        return (
          <Col xs={12} className={styles.yearWrap} key={year}>
            <div className={styles.yearLabel}>{year}</div>
            <div className={styles.monthWrap}>
              {monthStrings.map((monthString) => {
                const date = new Date(monthString)
                const label = date.toLocaleString('de-CH', { month: 'short' })
                // const label = new Intl.DateTimeFormat('de-CH', { month: 'short' }).format(new Date(`${monthString}-01`))
                const isActive = selected.includes(monthString)
                const isDisabled = isMonthDisabled(monthString)
                return (
                  <div
                    className={`${styles.month} ${isActive ? styles.active : ''} ${isMonthDisabled(monthString) ? styles.disabled : ''}`}
                    onClick={() => !isDisabled && handleSelect(monthString)}
                    key={monthString}
                  >
                    <div className={styles.inner}>{label}</div>
                  </div>
                )
              })}
            </div>
          </Col>
        )
      })}
    </Row>
  )
}

export default MultiMonthPicker
